<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card :width="modal ? '1000' : 'auto'">
        <v-card-title style="align-items: start">
          <v-row
            no-gutters
            align="start"
          >
            <h1
              v-if="isNew"
              class="headline font-weight-medium mb-2 mx-1 d-flex align-start"
            >
              {{ header }}
            </h1>
            <ChipsLabel
              v-if="isShowEstimate"
              :value="devProgress"
              :color="devProgress ? devProgress.color : ''"
            />
            <ChipsLabel
              v-if="isShowEstimate"
              :value="totalTimeSpentSeconds"
              :color="totalTimeSpentSeconds ? totalTimeSpentSeconds.color : ''"
              class="ml-2"
            />
            <ChipsLabel
              v-if="isShowEstimate"
              :value="factWithGrades"
              :color="factWithGrades ? factWithGrades.color : ''"
              class="ml-2"
            />
            <v-spacer />
            <IconBtnTooltip
              v-if="!isNew"
              icon="mdi-information-variant"
              :tooltip="infoText"
            />
            <v-menu
              v-if="!isNew"
              v-model="trackerEditMode"
              :close-on-content-click="false"
              left
              offset-x
            >
              <template #activator="{ on: onMenu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn
                      class="mx-2"
                      icon
                      v-on="{ ...onMenu, ...onTooltip }"
                    >
                      <v-icon :color="issueTrackerRef ? 'blue darken-1' : ''">
                        mdi-jira
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Код задачі Jira</span>
                </v-tooltip>
              </template>
              <v-card class="pa-5">
                <div class="d-flex align-center">
                  <CustomTextField
                    v-model="issueTrackerRef"
                    label="Jira"
                    append-icon="search"
                    :loading="loading"
                    @click:append="openIssue(issueTrackerRef)"
                    @change="assignJiraIssue"
                  />
                </div>
              </v-card>
            </v-menu>
            <MenuDownload
              v-if="!isNew"
              :location="`specifications/${id}/rpc/export-to-excel?culture=`"
              filename="Спецификации"
              extension="xlsx"
              tooltip="Завантажити у форматі Excel"
              :bottom="true"
            />
            <v-btn
              v-if="modal"
              icon
              class="modal__btn ml-1"
              @click="$emit('close', false)"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-col
              v-if="!isNew"
              class="pa-0"
            >
              <HoverItem
                v-if="!editMode"
                :item="header"
                :is-delete="false"
                class="mb-5 headline"
                @edit="editMode = true"
              />
              <TitleEditor
                v-else
                :value="header"
                label="Найменування специфікації"
                @apply="updateTitle"
                @close="editMode = false"
              />
            </v-col>
            <v-row
              v-if="isNew"
              dense
              class="d-flex align-start"
            >
              <v-col
                md="12"
                sm="12"
                class="pb-0"
              >
                <CustomTextField
                  v-model="title"
                  label="Найменування специфікації"
                  :hide-details="false"
                  class="px-1"
                  @change="isChanged = true"
                />
              </v-col>
            </v-row>
            <v-row
              dense
              class="d-flex align-start px-1"
            >
              <v-col class="py-0 pl-0 pr-2">
                <ClientSelect
                  v-model="client"
                  :client-id="client && client.id"
                  icon="search"
                  :label="clientTitle"
                  :error-messages="$v.client.title.$error ? errors.CLIENT : []"
                  :hide-details="false"
                  @input="setClientSpecification()"
                />
              </v-col>
              <v-col class="py-0 pl-0 pr-2">
                <CustomTextField
                  v-model="lead"
                  :readonly="!isNew"
                  :label="leadTitle"
                  :error-messages="$v.lead.$error ? errors.LEAD : []"
                  :hide-details="false"
                  @input="$v.lead.$touch()"
                  @change="isChanged = true"
                />
              </v-col>
              <v-col class="pa-0">
                <CustomTextField
                  v-model="crm"
                  label="Посилання на CRM"
                  append-icon="search"
                  @click:append="redirectCRM(crm)"
                  @change="setCRMSpecification"
                />
              </v-col>
            </v-row>
            <v-data-table
              v-if="isShowEstimate"
              :headers="totalHeaders"
              hide-default-footer
              hide-default-header
              :items="totalEstimate"
              :style="{ top: modal ? '0px' : '45px' }"
              class="fixed-total"
              no-data-text="Даних немає"
            >
              <template v-slot:item="{ item }">
                <tr style="background: #ECEFF1">
                  <td
                    v-for="(column, index) in totalHeaders"
                    :key="index"
                    class="px-1"
                    :style="column.style"
                  >
                    <v-chip
                      v-if="column.type === 'chips'"
                      label
                      small
                      outlined
                      :color="getColorTotalEstimate(item, column.value)"
                      style="height: 50px; width: 50px"
                      class="px-1"
                    >
                      <span>{{ `${column.text}:` }}<br>
                        {{ `${item[column.value]}` }}</span>
                    </v-chip>
                    <span
                      v-else
                      class="font-weight-bold mr-2"
                    >{{
                      item[column.value]
                    }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <AddSpecificationItem
              v-if="!isNew && sections.length <= 1"
              :loading="loading"
              :sections="sections"
              @create-specification-item="createSpecificationItem"
            />
            <SpecificationItems
              v-if="!isNew"
              :id="id"
              :loading-table="loading"
              :items="items"
              :sections="sections"
              @get-specification="getSpecification"
            />
          </v-form>
        </v-card-text>
        <v-card-actions v-if="isNew">
          <PrimaryBtn
            :has-warnings="$v.$invalid"
            :loading="loading"
            @click="save"
          />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientSelect from "@/components/selects/ClientSelect";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import * as specificationsApi from "../../../backend/specificationsApi.js";
import SpecificationItems from "./SpecificationItems.vue";
import AddSpecificationItem from "./AddSpecificationItem.vue";
import MenuDownload from "../../../components/MenuDownload.vue";
import HoverItem from "../../../components/HoverItem.vue";
import TitleEditor from "../../../components/TitleEditor.vue";
import ChipsLabel from "../../../components/ChipsLabel.vue";
import IconBtnTooltip from "../../../components/IconBtnTooltip.vue";

import { ERRORS } from "@/helpers";
import { requiredIf } from "vuelidate/lib/validators";
import itemsHeaders from "../../../helpers/itemsHeaders.js";
import _ from "lodash";

export default {
  components: {
    ClientSelect,
    PrimaryBtn,
    SpecificationItems,
    AddSpecificationItem,
    MenuDownload,
    HoverItem,
    TitleEditor,
    ChipsLabel,
    IconBtnTooltip,
  },

  props: ["id", "modal", "isModalClose", "modalMode"],

  data: () => ({
    title: "",
    client: null,
    lead: "",
    createdAt: "",
    issueTrackerRef: "",
    trackerEditMode: false,
    items: [],
    sections: [],
    loading: false,
    isChanged: false,
    actions: [],
    valid: false,
    editMode: false,
    author: "",
    devProgress: null,
    factWithGrades: null,
    totalTimeSpentSeconds: null,
    totalEstimate: [],
    isShowEstimate: false,
    crm: "",
    testIndex: 0,
  }),

  validations() {
    return {
      client: {
        id: {
          required: requiredIf(function() {
            return !this.lead;
          }),
        },
        title: {
          required: requiredIf(function() {
            return !this.lead;
          }),
        },
      },
      lead: {
        required: requiredIf(function() {
          return !this.client;
        }),
      },
    };
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    header() {
      return this.isNew
        ? "Створення специфікації"
        : this.title
          ? this.title
          : "Специфікація";
    },
    errors() {
      return {
        CLIENT: [ERRORS.REQUIRED],
        LEAD: [ERRORS.REQUIRED],
      };
    },
    clientTitle() {
      return this.isNew ? "Клієнт*" : "Клієнт";
    },
    leadTitle() {
      return this.isNew ? "Лід*" : "Лід";
    },
    totalHeaders() {
      return itemsHeaders.totalHeaders;
    },
    infoText() {
      return `Автор: ${
        this.author
      };  Дата створення: ${this.$options.filters.date(this.createdAt)}`;
    },
  },
  watch: {
    modalMode() {
      if(this.modalMode) {
        this.getSpecification();
      }
    },
    isModalClose() {
      this.title = null;
      this.client = null;
      this.lead = null;
      this.crm = null;
    },
  },
  created() {
    this.getSpecification();
    if (!this.testIndex) {
      this.testIndex = 0.25;
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const specification = {
        title: this.title,
        clientId: this.client?.id || null,
        lead: this.lead,
        crm: this.crm,
      };

      this.loading = true;

      try {
        const id = await specificationsApi.createSpecification(specification);
        this.$notifySuccess();
        this.$router.push({ path: `/specifications/${id}` });
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
    async getSpecification() {
      if (!this.id) {
        return;
      }
      this.loading = true;
      const data = await specificationsApi.getSpecification(this.id);
      this.title = data.title;
      this.client = data.client;
      this.lead = data.lead;
      this.createdAt = data.createdAt;
      this.author = data.author?.title || "Не вказано";
      this.issueTrackerRef = data.issueTrackerRef;
      this.crm = data.crm;
      this.isShowEstimate =
        !this.isNew &&
        (!!data.estimateAvg || !!data.estimateMin || !!data.estimateMax);
      this.testIndex = data.testIndex;
      this.setItems(data);
      this.setTotalEstimate(data);
      this.loading = false;
    },
    setItems(data) {
      let currentItems = data.items.map((c) => {
        const item = { ...c };
        item.estimateNormDev = item.estimateAvgDev;
        item.estimateNormAnalyst = item.estimateAvgAnalyst;
        item.estimateNorm = item.estimateAvgDev + item.estimateAvgAnalyst;
        item.estimateMin = item.estimateMinDev + item.estimateMinAnalyst;
        item.estimateMax = item.estimateMaxDev + item.estimateMaxAnalyst;
        item.estimateAvg = item.estimateMaxDev + item.estimateMaxAnalyst;
        item.testIndex = this.testIndex;
        return item;
      });

      const indexTestSection = currentItems.findIndex(
        (s) => s.isTestSection === true
      );
      const testSection = currentItems[indexTestSection];
      const testSectionTitle = testSection.section;
      currentItems.splice(indexTestSection, 1);
      // testSection
      const testSectionTasks = currentItems.filter(
        (t) => t.section === testSectionTitle
      );
      currentItems = currentItems.filter((t) => t.section !== testSectionTitle);
      testSectionTasks.unshift(testSection);
      // testSectionTasks
      const groupedItems = _.groupBy(currentItems, (i) => i.section);
      this.sections = Object.keys(groupedItems);
      this.sections.push(testSectionTitle);

      this.items = [];
      Object.keys(groupedItems).forEach((i) => {
        this.items.push(groupedItems[i]);
      });
      this.items = this.items.sort((a, b) => {
        if (a[0].sectionPosition < b[0].sectionPosition) {
          return -1;
        }
        if (a[0].sectionPosition > b[0].sectionPosition) {
          return 1;
        }
        return 0;
      });
      this.items.push(testSectionTasks);
    },
    setTotalEstimate(data) {
      if (!data) {
        return;
      }
      this.totalTimeSpentSeconds = {
        name: "Факт",
        text: +this.$options.filters.secondsToHours(data.totalTimeSpentSeconds),
      };
      this.factWithGrades = {
        name: "Факт з грейдами",
        text: data.factWithGrades,
        color:
          data.factWithGrades > data.estimateAvg
            ? "red"
            : data.factWithGrades > data.estimateMin &&
              data.factWithGrades <= data.estimateAvg
              ? "yellow darken-2"
              : data.factWithGrades <= data.estimateMin
                ? "green"
                : "grey lighten-2",
      };
      this.devProgress = {
        name: "Прогрес",
        text: `${data.devProgress}%`,
        color:
          data.devProgress === 0
            ? "grey"
            : data.devProgress > 100
              ? "red"
              : "grey lighten-2",
      };
      this.totalEstimate = [
        {
          title: "Загальна оцінка:",
          estimateAvg: data.estimateAvg,
          estimateMin: data.estimateMin,
          estimateNorm: data.estimateAvg,
          estimateMax: data.estimateMax,
        },
      ];
    },
    getColorTotalEstimate(item, estimateName) {
      switch (true) {
        case estimateName === "estimateMin" &&
          this.factWithGrades.text <= item.estimateMin:
          return "green";
        case estimateName === "estimateNorm" &&
          this.factWithGrades.text > item.estimateMin &&
          this.factWithGrades.text <= item.estimateAvg:
          return "#FBC02D";
        case estimateName === "estimateMax" &&
          this.factWithGrades.text > item.estimateAvg:
          return "red";
        default:
          return "default";
      }
    },
    async createSpecificationItem(item) {
      this.loading = true;
      await specificationsApi.createSpecificationItem(this.id, item);
      this.loading = false;
      this.getSpecification();
    },
    async setClientSpecification() {
      if (this.isNew) {
        return;
      }
      await specificationsApi.setClientSpecification(this.id, this.client.id);
      this.$notifySuccess();
    },
    async assignJiraIssue() {
      this.loading = true;
      await specificationsApi.setTrackerSpecification(
        this.id,
        this.issueTrackerRef
      );
      this.loading = false;
    },
    openIssue(jiraIssueKey) {
      window.open(
        `https://atominc.atlassian.net/browse/${jiraIssueKey}`,
        "_blank"
      );
    },
    async updateTitle(value) {
      await specificationsApi.updateSpecificationTitle(this.id, value);
      this.title = value;
      this.editMode = false;
    },
    redirectCRM(link) {
      if (link) {
        window.open(link, "_blank");
      }
    },
    async setCRMSpecification() {
      if (this.isNew) {
        return;
      }
      await specificationsApi.setCRMSpecification(this.id, this.crm);
      this.$notifySuccess();
    },
  },
};
</script>
<style>
.fixed-total {
  position: sticky;
  background: white;
  z-index: 3;
}
</style>
